module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_normal_blue-7e723ee29be05d590efa905b2bed80eb.svg";